import React, { useEffect, useState } from 'react';
import '../styles/NoirAlert.css';

const NoirAlert = ({ message, type, onClose }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (message) {
      setVisible(true);
      const timer = setTimeout(() => {
        setVisible(false);
        onClose();
      }, type === 'error' || type === 'warning' ? 7000 : 3000); // hatalar okunabilsin diye daha uzun

      return () => clearTimeout(timer);
    }
  }, [message, type, onClose]);

  if (!visible || !message) return null;

  return (
    <div className={`noiralert-container ${type}`} role={type === 'error' ? 'alert' : 'status'} aria-live="polite">
      <p>{message}</p>
    </div>
  );
};

export default NoirAlert;